import React from 'react'

export default (props) => (
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect width='40' height='40' rx='4' fill='#EEB556' />
    <path fillRule='evenodd' clipRule='evenodd' d='M22 18.9905L22 19C22.0007 18.9972 29.9995 18.9972 30 19C30 15 26.0011 11 22 11C22.0007 11 22 18.6833 22 18.9905ZM11 21C11 25.9706 15.0294 30 20 30C24.9706 30 29 25.9706 29 21H20V12C15.0294 12 11 16.0294 11 21ZM20 28C16.134 28 13 24.866 13 21C13 17.829 15.1085 15.1504 18 14.2899V16.5V23H24.5H26.7101C25.8496 25.8915 23.171 28 20 28ZM24.0003 13.4565L24.0003 15.0001L24.0002 16.9246L24.0002 16.9981L26.0001 16.9979L27.5428 16.998C26.8661 15.4847 25.5138 14.1327 24.0003 13.4565Z' fill='white' />
  </svg>
)
